import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {RichTextEditor} from '@syncfusion/ej2-angular-richtexteditor';
import {AdresseModels} from 'src/app/models/adresse-models';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';

@Component({
    selector: 'app-address-notiz',
    templateUrl: './address-notiz.component.html',
    styleUrls: ['./address-notiz.component.scss']
})
export class AddressNotizComponent implements OnInit {

    public adrNoteIsRichText = true;

    /* Felder */
    fldAdrNotizenKey = 'fldAdrNotizen';
    formGroupAdrNotiz: UntypedFormGroup = new UntypedFormGroup({
        fldAdrNotizen: new UntypedFormControl(),
    });

    @ViewChild('richTxtEditor1') rteObj1?: RichTextEditor;
    /* RichtText Editor */
    public tools: object = {
        items: [
            'Undo',
            'Redo',
            '|',
            'Bold',
            'Italic',
            'Underline',
            'StrikeThrough',
            '|',
            'FontName',
            'FontSize',
            'FontColor',
            'BackgroundColor',
            '|',
            'SubScript',
            'SuperScript',
            '|',
            'LowerCase',
            'UpperCase',
            '|',
            'Formats',
            'Alignments',
            '|',
            'OrderedList',
            'UnorderedList',
            '|',
            'Indent',
            'Outdent',
            '|',
            'CreateLink',
            'Image',
            '|',
            'ClearFormat',
            'Print',
            'SourceCode',
            '|',
            'FullScreen',
        ],
    };
    protected adrNoteValue = '';

    constructor(
        private svcSwissSettingsService: SwissSettingsService,
        public dialogRef: MatDialogRef<AddressNotizComponent>,
        @Inject(MAT_DIALOG_DATA) public data: AdresseModels.DetailAdresseElement) {

        this.adrNoteValue = this.data.note;
        this.adrNoteIsRichText = this.svcSwissSettingsService.getSwissAppConfig()?.richTextFormat_AdrNote === 1;
    }

    ngOnInit(): void {
        this.formGroupAdrNotiz.controls[this.fldAdrNotizenKey].setValue(this.adrNoteValue);
    }

    async save(): Promise<void> {
        if (this.adrNoteIsRichText) {
            const newValue = this.rteObj1!.value;
            if (this.adrNoteValue === newValue) {
                this.dialogRef.close(undefined);
            } else {
                this.dialogRef.close(newValue);
            }
        } else {
            const newValue = this.formGroupAdrNotiz.controls[this.fldAdrNotizenKey].value;

            if (this.adrNoteValue === newValue) {
                this.dialogRef.close(undefined);
            } else {
                this.dialogRef.close(newValue);
            }
        }
    }

}
